import { put, race, take, takeLatest, call, select } from 'redux-saga/effects';

import addressService from 'services/addressService';

import { types, validateAddressModal } from './actions';
import { VALIDATION_STATUSES } from './constants';
import { getOriginalAddress } from './reducer';

export default function* root() {
  yield takeLatest(types.VALIDATE_ADDRESS_REQUEST, watchValidateAddress);
}

function* watchValidateAddress(action) {
  try {
    const { callBack } = action.payload;
    if (!callBack) {
      console.error('Error: callback not provided to validate address flow');
      return;
    }

    const originalAddress = yield select(getOriginalAddress);
    // Validate the address
    const addressValidationResponse = yield call(
      addressService.validateAddress,
      originalAddress,
    );

    // Invalid Address
    if (!addressValidationResponse.isValid) {
      callBack({
        address: originalAddress,
        status: VALIDATION_STATUSES.INVALID,
      });
      return;
    }

    // Valid Address
    if (
      addressValidationResponse.isValid &&
      addressValidationResponse.suggestedAddresses.length == 0
    ) {
      callBack({
        address: originalAddress,
        status: VALIDATION_STATUSES.VALID,
      });
      return;
    }

    yield put(
      validateAddressModal.open({
        suggestedAddresses: addressValidationResponse.suggestedAddresses,
      }),
    );

    const winner = yield race({
      chooseAddress: take(types.VALIDATE_ADDRESS_MODAL_CHOOSE_ADDRESS),
      cancel: take(types.VALIDATE_ADDRESS_MODAL_CLOSE),
    });
    if (winner.chooseAddress) {
      // The user has selected an address
      callBack({
        address: winner.chooseAddress.payload.address,
        status: VALIDATION_STATUSES.ACCEPT,
      });
    } else if (winner.cancel) {
      callBack({
        address: originalAddress,
        status: VALIDATION_STATUSES.CANCEL,
      });
    }
  } catch (error) {
    console.error('Error validating address');
  }
}
